export default {"src":"/_next/static/media/pin_cocktail_green.6220089b.svg","height":29,"width":21,"blurWidth":0,"blurHeight":0};